let concat = "<br />";

const aboutAkara25 = {
  "About Akara Jan’25": [
    {
      question: "What are the important details of the Bond offering?",
      answer:
        "Issuer Name: Akara Capital Advisors Private Limited" +
        concat +
        "Security Name: AKARA CAPITAL ADVISORS PRIVATE LIMITED 10.01 NCD 21JN25 FVRS1LAC" +
        concat +
        "ISIN: INE08XP07159" +
        concat +
        "Nature of Instrument: Secured, Rated, Listed, Taxable, Redeemable, non-convertible debentures" +
        concat +
        "Seniority: Senior" +
        concat +
        "Date of Issue: 21st Jul’23" +
        concat +
        "Credit Rating: ICRA BBB/Stable Outlook" +
        concat +
        "Face Value: Rs. 1,00,000/Unit" +
        concat +
        "Coupon: Fixed" +
        concat +
        "Coupon Rate: 10.01% p.a. Payable Monthly" +
        concat +
        "Coupon Frequency: Monthly" +
        concat +
        "Principal Repayment: Quarterly (Refer the Cash Flow)" +
        concat +
        "Original Mode of Issue: Private Placement" +
        concat +
        "Listing Details: Bombay Stock Exchange (BSE)" +
        concat +
        "Maturity Date: 21st Jan’25" +
        concat +
        "Tenor: 18 months" +
        concat +
        "Debenture Trustee: Beacon Trusteeship Ltd" +
        concat,
    },
    {
      question: "What is the Security Cover for the Bond?",
      answer:
        "The Bond is secured by way of a first ranking, exclusive and continuing charge on identified loan receivables for 1.1x the outstanding amount of the Bond (including Interest accrued).",
    },
    {
      question:
        "What are the important covenants that the Issuer has to adhere to?",
      answer:
        "a. The Capital Adequacy Ratio (Tier 1 and Tier 2 capital) to be maintained above 20%" +
        concat +
        "b. Total Debt/ TNW not to exceed 3.5x" +
        concat +
        "c. Maximum permissible ratio of PAR 90+ write offs for trailing 12 months to total loan disbursements of trailing 12 months shall be 10%" +
        concat +
        "d. The Company shall ensure that the Net NPA is not more than 3.00%" +
        concat +
        "e. The Company shall maintain a minimum external credit rating of “ICRA BBB (Stable)" +
        concat,
    },
    {
      question: "Can I liquidate the bond before maturity?",
      answer:
        "Yes, you can liquidate the bond before maturity through our anytime liquidation feature. However, the liquidation will happen at a discount of 2% to the value of the bond.",
    },
    {
      question: "What is the Coupon payout dates?",
      answer:
        "The coupon would be paid out as per the attached cash flow. In case the Coupon Payment Date is not a Business Day, then the Coupon shall be payable on the immediately preceding Business Day.",
    },
    {
        question: "What is the record date for the payouts?",
        answer:
          "The date falling 15 (fifteen) Calendar Days prior to the relevant Payment Date.",
      },
      {
        question: "Why is the Current Face Value lower than the original Face Value?",
        answer:
          "The current Face Value is lower than the original Face Value due to a partial principal being repaid as per the scheduled cash flow.",
      },
      {
        question: "How is the Yield to Maturity (YTM) is calculated?",
        answer: "The Yield to Maturity is calculated using the XIRR formula present in Microsoft Excel or such other spreadsheets. The cash flow is populated in the spreadsheet along with the dates and the XIRR formula is then applied to get the YTM."
      }
  ],
};

export default aboutAkara25;